export const ASSETS = [{
    id: 0,
    image: "Banner.gif",
    title: 'Banner',
    description: 'Amazon brand store header graphic showcasing a looped animation with a wellness concept.',
    category: 'Poster',
},
{
    id: 1,
    image: "ww_carousel.png",
    title: 'Krill supplement carousel',
    description: 'Three slides showcasing the features, pricing and U.S.P. of the supplement.',
    category: 'Carousel',


},
{
    id: 2,
    image: 'cursor.png',
    title: 'Magazine Poster',
    description: 'College magazine to showcase covid and related articles written by the students.',
    category: 'Poster',


},
{
    id: 3,
    image: 'soundcloud.png',
    title: 'College Presentation',
    description: 'Redesign in re soundcloud website with a prototype and a brand guidline presentation.',
    category: 'Poster',
},
{
    id: 4,
    image: 'dw_chai.jpg',
    title: 'Social Media post',
    description: 'Showcasing international tea day.',
    category: 'Post',
    
},
{
    id: 5,
    image: 'dw_graph.png',
    title: 'Marketing Post',
    description: 'Design concept showing brand as a booster to compund up the sales with the right marketing partner.',
    category: 'Post',
    
},
{
    id: 6,
    image: 'dw_festive.jpg',
    title: 'Festive Post',
    description: 'Design for Guru Nanak Day by following a minimal concept.',
    category: 'Post',
    
},
{
    id: 7,
    image: 'ww_ad.png',
    title: 'Creative Ad',
    description: 'Creative ad to display a sleep supplement in order to attract a particular audience.',
    category: 'Post',
    
},
{
    id: 8,
    image: 'hemp.png',
    title: 'Crowdfunding graphic',
    description: 'Visual to attract the crowd and an ask for the support required for the community.',
    category: 'Post',
    
},
{
    id: 9,
    image: 'hemp_1.png',
    title: 'Awareness Prop',
    description: 'Prop to spread awareness regarding hemp and its benefits.',
    category: 'Post',
    
},
{
    id: 10,
    image: 'hemp_2.png',
    title: 'Marketing ad',
    description: '',
    category: 'Post',
    
},
{
    id: 11,
    image: 'rnb.jpg',
    title: 'Festive Ad',
    description: 'Graphic to showcase the legal day.',
    category: 'Post',
    
},
{
    id: 12,
    image: 'ww_post.png',
    title: 'Module',
    description: 'Module for A+ Premium graphics.',
    category: 'Post',
    
},
{
    id: 13,
    image: 'ww_post1.png',
    title: 'Creative Ad',
    description: '',
    category: 'Post',
    
},
{
    id: 14,
    image: 'nectar.png',
    title: 'Genearl Post',
    description: 'Ad to showcase the software and its benefits.',
    category: 'Post',
    
},
{
    id: 15,
    image: 'nectar_1.png',
    title: 'Genearl Post',
    description: '',
    category: 'Post',
    
},
{
    id: 16,
    image: 'nectar_2.png',
    title: 'General Post',
    description: '',
    category: 'Post',
    
},
{
    id: 17,
    image: 'underaman.png',
    title: 'Product Carousel',
    description: 'Products display in a creative carousel for awarenesProducts display in a creative carousel for awareness.',
    category: 'Carousel',
},
{
    id: 18,
    image: 'ww_carousel_1.png',
    title: 'Product Carousel',
    description: '',
    category: 'Carousel',
},
{
    id: 19,
    image: 'lgbtq.png',
    title: 'Creative Ad',
    category: 'test',
    description: 'Spreading awareness for the community.',
    category: 'Post',
    
},
{
    id: 20,
    image: 'dw_festive1.jpg',
    title: 'Festive Post',
    description: '',
    category: 'Post',
    
},
{
    id: 21,
    image: 'aids.png',
    title: 'Creative Ad',
    category: 'Festive Post',
    description: 'The world aids day.',
    category: 'Post',
    
},
{
    id: 22,
    image: 'capsule.png',
    title: 'Marketing ad',
    description: '',
    category: 'Other',
    
},
{
    id: 23,
    image: 'tagline.png',
    title: 'Tagline Post',
    description: '',
    category: 'Other',
    
},
{
    id: 24,
    image: 'techabled.png',
    title: 'Infographic',
    description: '',
    category: 'Other',
    
}




];

export const ANIMATIONS = [{

    id: 0,
    video: 'par.mp4',
    category: 'Animation',
    poster: 'par.jpg'
},
{
    id: 1,
    video: 'par_1.mp4',
    category: 'Animation',
    poster: 'par_1.jpg'
},
{
    id: 2,
    video: 'dw_christmas.mp4',
    poster: 'dw_christmas.jpg',
    category: 'Animation',
},
{
    id: 3,
    video: 'hemp_festive.mp4',
    poster: 'christmas.jpg',
    category: 'Animation',
},
{
    id: 4,
    video: 'dw_navy.mp4',
    poster: 'dw_navy.jpg',
    category: 'Animation',
},
{
    id: 5,
    video: 'Krill.mp4', 
    poster: 'krill.jpg',
    category: 'Animation',
},
{
    id: 6,
    video: 'Greens.mp4', 
    poster: 'greens.jpg',
    category: 'Animation',
}

];

export const DOCUMENTS = [{

    id: 0,
    pdf: 'cursor_magazine.pdf',
    category: 'Other',
    width: '380px',
    height: '500px'

},
{
    id: 1,
    pdf: 'omni.pdf',
    category: 'Other',
    width: '380px',
    height: '500px'
},
{
    id: 2,
    pdf: 'soundcloud.pdf',
    category: 'Other',
    width: '750px',
    height: '400px'
}
] 
